export default __webpack_public_path__ + "static/media/many_success.c23c9420.svg";